import React from 'react';
import styled from 'styled-components'
import Toggle from './toggle';
import useDarkMode from 'use-dark-mode';
import { orange, charcoal, smoke, darkSmoke } from '../../utils/colors';

const DarkModeToggle = () => {
  const darkMode = useDarkMode(false);

  return (
    <DarkModeToggleWrapper className="dark-mode-toggle">
      <Sun type="button" onClick={darkMode.disable} checked={darkMode.value}>
        ☀
      </Sun>
      <Toggle checked={darkMode.value} onChange={darkMode.toggle} />
      <Moon type="button" onClick={darkMode.enable} checked={darkMode.value}>
        ☾
      </Moon>
    </DarkModeToggleWrapper>
  );
};

export default DarkModeToggle;

const DarkModeToggleWrapper = styled.div`
display: flex;
  & > button {
    font-size: 1.2em;
    background: none;
    border: none;
    cursor: pointer;
    transition: color 0.3s ease;

    &:focus {
      outline: none;
    }
  }
`

const Sun = styled.button`
 color: ${props => (props.checked ? `${smoke}` : `${orange}`)};
`

const Moon = styled.button`
  color: ${props => (props.checked ? 'lightblue' : `#777`)};
`